/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type SelfRegistrationCompleteRegistrationInput = {
    firstname: string;
    lastname: string;
    email?: string | null;
    password: string;
    token: string;
    entitynumber: string;
    cellNumber: string;
    userDefinedRegion: string;
    clientMutationId?: string | null;
};
export type SelfRegistrationCompleteRegistrationMutationVariables = {
    input: SelfRegistrationCompleteRegistrationInput;
};
export type SelfRegistrationCompleteRegistrationMutationResponse = {
    readonly selfRegistrationCompleteRegistration: {
        readonly clientMutationId: string | null;
        readonly token: string;
        readonly username: string;
    } | null;
};
export type SelfRegistrationCompleteRegistrationMutation = {
    readonly response: SelfRegistrationCompleteRegistrationMutationResponse;
    readonly variables: SelfRegistrationCompleteRegistrationMutationVariables;
};



/*
mutation SelfRegistrationCompleteRegistrationMutation(
  $input: SelfRegistrationCompleteRegistrationInput!
) {
  selfRegistrationCompleteRegistration(input: $input) {
    clientMutationId
    token
    username
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SelfRegistrationCompleteRegistrationPayload",
    "kind": "LinkedField",
    "name": "selfRegistrationCompleteRegistration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SelfRegistrationCompleteRegistrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SelfRegistrationCompleteRegistrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fbc3a8aa8418181dd0755ebb0d5ed7f3",
    "id": null,
    "metadata": {},
    "name": "SelfRegistrationCompleteRegistrationMutation",
    "operationKind": "mutation",
    "text": "mutation SelfRegistrationCompleteRegistrationMutation(\n  $input: SelfRegistrationCompleteRegistrationInput!\n) {\n  selfRegistrationCompleteRegistration(input: $input) {\n    clientMutationId\n    token\n    username\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f1270742ec0dff44805fc6203525ebf9';
export default node;
